import React from 'react'
import {Card, CardHeader, Col, FormGroup, Input, Media, Table,} from "reactstrap";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import ErrorModal from "../Alerts/ErrorModal";
import reportApiService from "../../api/report-api-service";
import Button from "reactstrap/es/Button";
import dateHelpers from "../../helpers/DateHelper";
import Select from "react-select";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const eventNames = [
    {value: "0", label: "all"},
    {value: "1", label: "new-user-created"},
    {value: "1", label: "student_created"},
    {value: "1", label: "pdf-zip-requested"},
    {value: "1", label: "new-user-students-connected"},
    {value: "1", label: "client_app_ticket_sold"},
    {value: "1", label: "invoice_sent_to_student"},
    {value: "1", label: "student_connected"},
    {value: "1", label: "booking_made"},
    {value: "1", label: "booking_cancelled"},
    {value: "1", label: "error"},
    {value: "1", label: "business_message"},
    {value: "1", label: "payment_intent_created"},
    {value: "1", label: "free_trial_rejected"},
    {value: "1", label: "subscriptions_view"},
    {value: "1", label: "subscription_selected"},
    {value: "1", label: "free_trial_activated"},
    {value: "1", label: "unsubscribed"},
    {value: "1", label: "ssl_certificate_revoked"},
    {value: "1", label: "notification_failed"},
    {value: "1", label: "daily_report_sent"},
    {value: "1", label: "email_click_ios_m"},
    {value: "1", label: "email_click_android_m"},
    {value: "1", label: "email_click_website"},
    {value: "1", label: "subscription_purchased"},
    {value: "1", label: "gcm_invalid_registration_id"},
    {value: "1", label: "notification_id_failed"},
    {value: "1", label: "stripe_e_payment_succeeded"},
    {value: "1", label: "stripe_e_subscription_deleted"},
    {value: "1", label: "web_news_requested"},
    {value: "1", label: "subscriptions_cur_selected"},
    {value: "1", label: "about_view"},
    {value: "1", label: "email_click_android_c"},
    {value: "1", label: "coupon_applied"},
    {value: "1", label: "coupon_entered"}].sort(function(a, b){
    if(a.label < b.label) { return -1; }
    if(a.label > b.label) { return 1; }
    return 0;
});

const propTypes = {};

export default class AhoyEvents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: eventNames[1],
            userId: props.adminUserSelectedId || -1,
            userName: "",
            numberOfEvents: 100,
            events: null,
            isLoading: false,
            userNames: [],
        };
    }

    //handleNameSelected = this.handleNameSelected.bind(this)
    handleChange = this.handleChange.bind(this)
    onUserIdSelected = this.onUserIdSelected.bind(this)

    componentDidMount() {
        this.getData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.searchValue !== this.state.searchValue) {
            this.getData()
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleNameSelected = selectedOption => {
        this.setState({
                searchValue: selectedOption,
            }
        )
    };

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Card className="bg-default shadow">
                        <Row style={{marginLeft: 4}}>
                            <Col lg="5">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-name"
                                    >
                                        Select event name
                                    </label>
                                    <Select
                                        id="input-name"
                                        className="form-control-alternative"
                                        value={this.state.searchValue}
                                        placeholder={commonStrings.select}
                                        onChange={this.handleNameSelected}
                                        options={eventNames}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-id"
                                    >
                                        {(this.state.userName && this.state.userName.length > 0) ? this.state.userName : "Enter User ID"}
                                    </label>
                                    <Input
                                        style={{height: "38px"}}
                                        className="form-control-alternative"
                                        defaultValue={-1}
                                        value={this.state.userId}
                                        onChange={this.handleChange}
                                        id="input-id"
                                        type="number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="3">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-last"
                                    >
                                        Number of events
                                    </label>
                                    <Input
                                        style={{height: "38px"}}
                                        className="form-control-alternative"
                                        defaultValue={this.state.numberOfEvents}
                                        value={this.state.numberOfEvents}
                                        onChange={this.handleChange}
                                        id="input-last"
                                        type="number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="auto" style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Button
                                    color="success"
                                    size="lg"
                                    onClick={e => this.handleSubmit(e)}
                                >
                                    GO
                                </Button>
                            </Col>
                        </Row>
                        <Card className="bg-default shadow">
                            <CardHeader className="bg-transparent">
                                <Row>
                                    <h5 className="text-warning mb-0">EVENTS</h5>
                                </Row>
                            </CardHeader>
                            {this.state.events !== null && this.renderReport()}
                        </Card>
                    </Card>
                </>
            </LoadingOverlay>
        )
    }


    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-id":
                this.setState({userId: newValue});
                break;
            case "input-last":
                this.setState({numberOfEvents: newValue});
                break;
            default:
                break;
        }
    }

    renderReport() {
        return <Col lg="12">
            <Card>
                <Table
                    className="align-items-center table-light table-flush mt-2"
                    responsive
                >
                    <thead className="thead-light">
                    <tr>
                        <th scope="col">time</th>
                        <th scope="col">name</th>
                        <th scope="col">user</th>
                        <th scope="col">user id</th>
                        <th scope="col">properties</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.renderTable()}
                    </tbody>
                </Table>
            </Card>
        </Col>
    }

    renderTable() {
        if (this.state.events !== null) {
            return this.state.events.map((event, index) => {
                return (
                    <tr>
                        <td>
                            {dateHelpers.databaseDateTime(new Date(event.time))}
                        </td>
                        <th scope="row">
                            <Media className="align-items-center">
                                <span className="mb-0 text-sm">
                                    {event.name}
                                </span>
                            </Media>
                        </th>
                        <td>
                            {this.getUserName(event)}
                        </td>
                        <td>
                            <a href="#" onClick={(e) => this.onUserIdSelected(e, event.user_id)}>{event.user_id}</a>
                        </td>
                        <td>
                            {event.properties ? JSON.stringify(event.properties) : ""}
                        </td>
                    </tr>
                )
            })
        }
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    getUserName(event) {
        const user = this.state.userNames.find(it => it.id === event.user_id)
        return user ? user.name : "";
    }

    getData() {
        if (this.state.searchValue !== null) {
            this.setState({isLoading: true});
            reportApiService.admin_all_events(this.state.searchValue.label, this.state.numberOfEvents, this.state.userId || -1)
                .then(res => {
                    this.setState({
                        isLoading: false,
                        events: res.events,
                        userName: res.name,
                        userNames: res.users
                    });
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    handleSubmit(e) {
        e.preventDefault()
        this.getData()
    }

    onUserIdSelected(e, user_id) {
        e.preventDefault();
        this.setState({userId: user_id})
    }
}

AhoyEvents.propTypes = propTypes;